/** project lookup `settings.EARN_POLICY` (mashup ENUM_SINGLE) */
export interface EarnPolicySetting {
  type: 'ENUM_SINGLE'
  value: string
}

/** 간편가입 허용 값 */
export const EARN_POLICY_ALLOWED = 'ALLOWED'

/**
 * settings.EARN_POLICY 기준 간편가입 사용 여부.
 * `{ "type": "ENUM_SINGLE", "value": "ALLOWED" }` 일 때 true.
 * 간편가입 UI는 search의 createScope와 함께 이 값이 ALLOWED일 때만 노출한다.
 */
export function isSimpleSignupEnabled(policy: unknown): boolean {
  if (policy == null || typeof policy !== 'object') return false

  const p = policy as Partial<EarnPolicySetting>
  if (p.type !== 'ENUM_SINGLE') return false

  return String(p.value ?? '').trim().toUpperCase() === EARN_POLICY_ALLOWED
}
